import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { departmentsAPI } from '../../services/api';

// Асинхронные экшены
export const fetchDepartments = createAsyncThunk(
  'departments/fetchDepartments',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await departmentsAPI.getAll(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchDepartmentById = createAsyncThunk(
  'departments/fetchDepartmentById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await departmentsAPI.getById(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Slice
const departmentsSlice = createSlice({
  name: 'departments',
  initialState: {
    items: [],
    selectedDepartment: null,
    loading: false,
    error: null,
  },
  reducers: {
    // Синхронное обновление департамента (используется при получении событий)
    updateDepartment: (state, action) => {
      const department = action.payload;
      const index = state.items.findIndex(item => item.id === department.id);
      
      if (index !== -1) {
        // Обновление существующего департамента
        state.items[index] = {
          ...state.items[index],
          ...department,
        };
      } else {
        // Добавление нового департамента
        state.items.push(department);
      }
      
      // Если открыта детальная страница департамента, обновляем и её
      if (state.selectedDepartment && state.selectedDepartment.id === department.id) {
        state.selectedDepartment = {
          ...state.selectedDepartment,
          ...department,
        };
      }
    },
    
    // Удаление департамента (используется при получении событий)
    deleteDepartment: (state, action) => {
      const id = action.payload;
      state.items = state.items.filter(item => item.id !== id);
      
      // Если открыта детальная страница удаляемого департамента, очищаем её
      if (state.selectedDepartment && state.selectedDepartment.id === id) {
        state.selectedDepartment = null;
      }
    },
    
    // Сброс выбранного департамента
    resetSelectedDepartment: (state) => {
      state.selectedDepartment = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Обработка fetchDepartments
      .addCase(fetchDepartments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDepartments.fulfilled, (state, action) => {
        // Handle both direct array and wrapped response formats
        const responseData = action.payload;
        state.items = Array.isArray(responseData) ? responseData : (responseData?.data || []);
        state.loading = false;
      })
      .addCase(fetchDepartments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Не удалось загрузить департаменты';
      })
      
      // Обработка fetchDepartmentById
      .addCase(fetchDepartmentById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDepartmentById.fulfilled, (state, action) => {
        state.selectedDepartment = action.payload;
        state.loading = false;
      })
      .addCase(fetchDepartmentById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Не удалось загрузить департамент';
      });
  },
});

// Экспорт экшенов
export const { updateDepartment, deleteDepartment, resetSelectedDepartment } = departmentsSlice.actions;

// Селекторы
export const selectAllDepartments = (state) => state.departments.items;
export const selectSelectedDepartment = (state) => state.departments.selectedDepartment;
export const selectDepartmentsLoading = (state) => state.departments.loading;
export const selectDepartmentsError = (state) => state.departments.error;

// Экспорт редьюсера
export default departmentsSlice.reducer; 